import { Typography } from '@mui/material';

import { PopupVariants } from './types';
import LoginForm from './blocks/login-form/loginForm';
import { DocumentView } from './city-people/document-view';
import { BlockType } from '../../../../types/page-generator';
import { MessageCityPeople } from './city-people/message-city-people';
import { PaymentCityPeople } from './city-people/payment-city-people';
import { ApproveOrderCityPeople } from './city-people/approve-order';
import { ConfirmCityPeople } from './city-people/confirm-city-people';
import { LoginCityPeople } from './city-people/login-form-city-people';
import {
  Place,
  LeadV1,
  HappyHr,
  Present,
  AddCard,
  Newsletter,
  VendorsDetails,
  VendorsBranches,
} from './blocks';
import { DefaultRegistration } from './blocks/default-registration';
import { PasportNumberAndCode } from './blocks/pasport-number-and-code';
import { Seller } from './blocks/seller';
import { Buyer } from './blocks/buyer';
import { DealFinished } from './blocks/deal-finished';
import { Distance } from './blocks/distance';
import { WantBuy } from './blocks/want-buy';
import { WantSell } from './blocks/want-sell';
import { MatchMe } from './blocks/match-me';
import { CheckCard } from './blocks/check-card';

export default function Showcase({ block }: { block: BlockType }) {
  switch (block.variant) {
    case PopupVariants.leadv1:
      return <LeadV1 block={block} />;
    case PopupVariants.happyHr:
      return <HappyHr block={block} />;
    case PopupVariants.newsletter:
      return <Newsletter block={block} />;
    case PopupVariants.seller:
      return <Seller block={block} />;
    case PopupVariants.buyer:
      return <Buyer block={block} />;
    case PopupVariants.dealFinished:
      return <DealFinished block={block} />;
    case PopupVariants.distance:
      return <Distance block={block} />;
    case PopupVariants.wantSell:
      return <WantSell block={block} />;
    case PopupVariants.wantBuy:
      return <WantBuy block={block} />;
    case PopupVariants.matchMe:
      return <MatchMe block={block} />;
    case PopupVariants.place:
      return <Place block={block} />;
    case PopupVariants.present:
      return <Present block={block} />;
    case PopupVariants.vendorsDetails:
      return <VendorsDetails block={block} />;
    case PopupVariants.vendorsBranches:
      return <VendorsBranches block={block} />;
    case PopupVariants.addCard:
      return <AddCard block={block} />;
    case PopupVariants.loginForm:
      return <LoginForm block={block} />;
    case PopupVariants.defaultRegistration:
      return <DefaultRegistration block={block} />;
    case PopupVariants.pasportNumberAndCode:
      return <PasportNumberAndCode block={block} />;
    case PopupVariants.loginFormCityPeople:
      return <LoginCityPeople block={block} />;
    case PopupVariants.messageCityPeople:
      return <MessageCityPeople block={block} />;
    case PopupVariants.paymentCityPeople:
      return <PaymentCityPeople block={block} />;
    case PopupVariants.approveOrder:
      return <ApproveOrderCityPeople block={block} />;
    case PopupVariants.confirmCityPeople:
      return <ConfirmCityPeople block={block} />;
    // case PopupVariants.walletCityPeople:
    //   return <LoginForm block={block} />;
    case PopupVariants.documentView:
      return <DocumentView block={block} />;
    case PopupVariants.checkCard:
      return <CheckCard block={block} />;
    default:
      return (
        <Typography>
          There is no block from &quot;Popup&quot; group registered with such variant
        </Typography>
      );
  }
}
